import { get, writable } from "svelte/store";
import { getFromLocalStorage, saveToLocalStorage } from "./utils.js";

const generalTimePeriods = [
  { value: "weekly", label: "Weekly Stats" },
  { value: "monthly", label: "Monthly Stats" },
  { value: "quarterly", label: "Quarterly Stats" },
  { value: "yearly", label: "Yearly Stats" },
  { value: "allTime", label: "All Time Stats" },
];

const specificTimePeriods = [
  { value: "thisWeek", label: "This Week" },
  { value: "lastWeek", label: "Last Week" },
  { value: "thisMonth", label: "This Month" },
  { value: "lastMonth", label: "Last Month" },
  { value: "thisQuarter", label: "This Quarter" },
  { value: "lastQuarter", label: "Last Quarter" },
  { value: "thisYear", label: "This Year" },
  { value: "lastYear", label: "Last Year" },
  { value: "allTime", label: "All Time" },
];

export const timeOptions = {
  statCard: [{ value: "daily", label: "Daily Stats" }, ...generalTimePeriods],
  benchmarks: generalTimePeriods,
  leaderboard: [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    ...specificTimePeriods,
  ],
  heatmap: specificTimePeriods,
};

const getDefaultTimeOption = (key, value) => {
  const storedOption = getFromLocalStorage(`${key}TimeOption`);
  if (storedOption) {
    return {
      key,
      option: storedOption,
    };
  }
  return {
    key,
    option: timeOptions[key].find((option) => option.value === value),
  };
};

export const selectedStatCardTimeOption = writable(
  getDefaultTimeOption("statCard", "monthly"),
);
export const selectedBenchmarksTimeOption = writable(
  getDefaultTimeOption("benchmarks", "monthly"),
);
export const selectedLeaderboardTimeOption = writable(
  getDefaultTimeOption("leaderboard", "thisMonth"),
);
export const selectedHeatmapTimeOption = writable(
  getDefaultTimeOption("heatmap", "allTime"),
);

const updateStore = (store, timeOption) => {
  store.update((x) => ({ ...x, option: timeOption }));
};

const updateElementTimeOption = (store, timeOption, key) => {
  const localStorageKey = `${key}TimeOption`;
  updateStore(store, timeOption);
  saveToLocalStorage(localStorageKey, timeOption);
};

export const handleTimeOptionChange = (store, timeOption) => {
  const val = get(store);
  if (timeOption.value !== val.option.value) {
    updateElementTimeOption(store, timeOption, val.key);
  }
};
